module.exports = __webpack_public_path__ + "img/phone-landline.21648959.svg";